import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background: #f0f3fa;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
`;

export const Content = styled.div`
  width: 100%;
  text-align: center;
`;

export const InvaliadImage = styled.img`
  width: 518px;
  height: 136px;
  margin-bottom: 30px;
`;

export const Title = styled.h1`
  width: 100%;
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  margin-bottom: 10px;
`;

export const Message = styled.p`
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
`;
